module.exports = __webpack_public_path__ + "static/assets/svakalimenka.35c4d460.png";